<script setup lang="ts">
import { useCalculationStore } from '@/stores/calculation'
import ImageDialog from '@/components/calculation-result/ImageDialog.vue'
import CrossSectionImage from '@/components/calculation-result/CrossSectionImage.vue'
import { computed } from 'vue'
import { CROSS_SECTION, LENGTH_SECTION, PLAN_VIEW } from '@/stores/type/calculation.type'
const calculationStore = useCalculationStore()

const { currentItem: currentCalculation } = storeToRefs(calculationStore)

const imageUrl = ref<string>()
const isShowDialog = ref(false)

const calculationType = computed<string>(() => {
  return currentCalculation.value?.calculation_type.toLowerCase() ?? ''
})

const getImageUrl = (sectionDirection: string) => {
  return `/img/${calculationType.value}_${sectionDirection}.png`
}

const planViewImageUrl = computed(() => {
  return getImageUrl(PLAN_VIEW)
})
const crossSectionImageUrl = computed(() => {
  return getImageUrl(CROSS_SECTION)
})
const lengthSectionImageUrl = computed(() => {
  return getImageUrl(LENGTH_SECTION)
})

const handleShowDialog = (url: string | null) => {
  isShowDialog.value = !isShowDialog.value
  imageUrl.value = url ?? imageUrl.value
}
</script>

<template>
  <v-row no-gutters>
    <v-col cols="4">
      <CrossSectionImage :image-url="crossSectionImageUrl" @handle-dialog="handleShowDialog" />
    </v-col>
    <v-col cols="4">
      <CrossSectionImage :image-url="lengthSectionImageUrl" @handle-dialog="handleShowDialog" />
    </v-col>
    <v-col cols="4">
      <CrossSectionImage :image-url="planViewImageUrl" @handle-dialog="handleShowDialog" />
    </v-col>

    <ImageDialog
      :dialog="isShowDialog"
      v-if="imageUrl"
      :src="imageUrl"
      @handle-dialog="handleShowDialog"
    />
  </v-row>
</template>

<style scoped>
.v-img {
  cursor: pointer;
}
</style>
